<template>
    <li class="nav-item company-switcher">
        <v-select
            v-model="currentUserCompany"
            :clearable="false"
            label="text"
            :options="options"
            class="dont-capitalize"
            style="width: 310px"
            @input="value => switchCompany(value)"
        />

        <!-- <b-form-select
            :value="currentUserCompany"
            :options="options"
            style="width: 200px"
            @change="value => $store.commit('company/UPDATE_CURRENT_COMPANY', value)"
        /> -->
    </li>
</template>

<script>
import vSelect from 'vue-select';
import { mapGetters } from "vuex";
import Company from '@/models/Company';
import updateCompanyInStore from '@/middlewares/updateCompanyInStore';
import { sleep } from '@/helpers';
// import { getUserCompanies } from '@/apis/company';

export default {
    components: {
        vSelect
    },

    data() {
        return {
            currentUserCompany: {
                text: '',
                value: ''
            }
        };
    },

    computed: {
        ...mapGetters({
            companies: 'company/getAllUserCompanies',
        }),

        options() {
            const {companies} = this;
        
            const options = companies.map(company => {
                const text = `${company?.name } ${ company?.company_type?.name}`;
                const value = company.id;
                return {value, text};
            });

            options.unshift({ value: 'default', text: 'Switch Company' });

            return options;
        }
    },

    async mounted() {
        // * when user comes from onboarding we load company list but vue mounted this CompanySwitcher somehow 
        // * faster than api calls + store data update, so we've waited 1 second to finish api and store work
        await sleep(1200);

        // eslint-disable-next-line prefer-destructuring
        this.currentUserCompany = this.options[0];
    },

    methods: {
        async switchCompany(data) 
        {
            await Company.switchCompany(data.value);
            await updateCompanyInStore();

            window.location.href = '/';

            // eslint-disable-next-line prefer-destructuring
            this.currentUserCompany = this.options[0];
        }
    },

};
</script>

<style>
    .company-switcher .vs__dropdown-menu {
        text-transform: none;
    }
</style>
